import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Rail, RailContainer } from 'components/Rail';
import { checkForPackage } from 'components/packages/getPackage';
import MidresponsiveAd from 'components/Ad/Midresponsive';
import * as CustomPropTypes from 'lib/CustomPropTypes';

import getPackagesForZone from '../getPackagesForZone';

import styles from './styles.module.scss';

function LeftRail({ packages }, context) {
  const { isFirstRail, vertical } = context;
  const hasTitle = checkForPackage(packages, 'collectionTitle', 1);
  const containerClasses = classNames('layout-leftRail', { hasTitle }, 'layout-grid-container');
  const leftClasses = classNames('layout-grid-item', {
    'grid-col-5-l grid-col-4-xl': vertical === 'today',
    'grid-col-4-l': vertical !== 'today',
  });
  const rightClasses = classNames(styles.right, 'layout-grid-item', {
    'grid-col-7-l grid-col-8-xl': vertical === 'today',
    'grid-col-8-l': vertical !== 'today',
  });

  return (
    <React.Fragment>
      <RailContainer className={containerClasses}>
        <Rail className={leftClasses}>
          {getPackagesForZone(1, packages, { ...context, railContext: 'left' })}
        </Rail>
        <div className={rightClasses}>
          {getPackagesForZone(2, packages, { ...context, isRailAdjacent: true })}
        </div>
      </RailContainer>

      {isFirstRail && <MidresponsiveAd />}
    </React.Fragment>
  );
}

LeftRail.propTypes = {
  packages: PropTypes.arrayOf(CustomPropTypes.package).isRequired,
};

LeftRail.contextTypes = {
  ...CustomPropTypes.layoutContext,
};

export default LeftRail;
